// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SearchResults_Wrapper__2lJyx","Result":"SearchResults_Result__3v6Ym"};